import { erpAxios } from '..';

const stepsCompleted = async (brojZahtjeva) => {
  const { data } = await erpAxios(`/loanApplication/stepsCompleted/${brojZahtjeva}`);
  return data;
};

export default stepsCompleted;
